import { render, staticRenderFns } from "./ReviewDialog.vue?vue&type=template&id=fb062006&scoped=true"
import script from "./ReviewDialog.vue?vue&type=script&lang=js"
export * from "./ReviewDialog.vue?vue&type=script&lang=js"
import style0 from "./ReviewDialog.vue?vue&type=style&index=0&id=fb062006&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb062006",
  null
  
)

export default component.exports